import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import GroupBarchart from "../../../d3Components/NewBarchart/GroupBarchart";
import ContainerDimensions from "react-container-dimensions";
import GroupBarWithLine from "../../../d3Components/groupBarWithLineChart/groupBarWithLine";

import Spinner from "../../../PortfolioDashboard/navigationPages/common/spinner/spinner.jsx";

class BarChartHolder extends Component {
  state = {
    dec_data: [],
    acc_data: [],
    investMentGlidePath: []
  };
  componentWillMount() {
    const { acc_data, investMentGlidePath } = this.props;
    this.setState({
      dec_data: this.props.dec_barchartData,
      acc_data,
      investMentGlidePath
    });
  }
  componentWillReceiveProps(newProps) {
    const { acc_data, investMentGlidePath } = newProps;

    this.setState({
      dec_data: newProps.dec_barchartData,
      acc_data,
      investMentGlidePath
    });
  }

  render() {
    const { dec_data, acc_data, investMentGlidePath } = this.state;
    const {
      excess,
      display,
      acc_selectedPortfolio,
      activeGlidePath,
      rate,
      fundName,
      acc_fundName,
      groupBarWithLineLabels
    } = this.props;

    return (
      <div className="row">
        {display === "accumulation" ? (
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            {!activeGlidePath ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <h4 className="text-uppercase bold">YoY Accumulation</h4>
                <h4 className="text-uppercase bold">
                  Selected Portfolio -{acc_fundName}(
                  {acc_selectedPortfolio.toFixed(2)}%)
                </h4>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <h4 className="text-uppercase bold">YoY Accumulation</h4>
              </div>
            )}
            {!activeGlidePath ? (
              <Fragment>
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 ? (
                        <GroupBarchart
                          containerWidth={width}
                          height={300}
                          data={acc_data}
                          targetDiv="rig_barchart02"
                          yAxisText={false}
                          toolTipPercent={false}
                          dollar={true}
                          textOnTopOfBar={true}
                        />
                      ) : null}
                    </Fragment>
                  )}
                </ContainerDimensions>{" "}
              </Fragment>
            ) : (
              <Fragment>
                <ContainerDimensions>
                  {({ width }) => (
                    <Fragment>
                      {width > 0 && investMentGlidePath.length > 0 ? (
                        <GroupBarWithLine
                          width={width}
                          data={investMentGlidePath}
                          id="rig_barchart02"
                          labels={groupBarWithLineLabels}
                        />
                      ) : (
                        <Spinner />
                      )}
                    </Fragment>
                  )}
                </ContainerDimensions>
              </Fragment>
            )}
          </div>
        ) : (
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              <h4 className="text-uppercase bold">
                {excess < 0 ? "YOY augmentation" : "YOY Depletion"}{" "}
              </h4>
              <h4 className="text-uppercase bold">
                Selected Portfolio - {fundName}({rate.toFixed(2)}%)
              </h4>
            </div>
            <ContainerDimensions>
              {({ width }) => (
                <Fragment>
                  {width > 0 ? (
                    <GroupBarchart
                      containerWidth={width}
                      height={300}
                      data={dec_data}
                      targetDiv="rig_barchart01"
                      yAxisText={false}
                      toolTipPercent={false}
                      dollar={true}
                      textOnTopOfBar={true}
                    />
                  ) : null}
                </Fragment>
              )}
            </ContainerDimensions>
          </div>
        )}
      </div>
    );
  }
}

export default connect(
  ({
    retirement: {
      rig: {
        intro: { selectedPlan },
        equation: {
          age,
          savings,
          income,
          withdraw,
          dec_barchartData,
          donut: { shortfall, rate, excess },
          fundSelected: { portfolio },
          dec_socialSecurity,
          dec_otherIncome,
          dec_investmentSource,
          fundSelected: { fundName }
        },
        accumulation: {
          currentSavings,
          possibleAnnualSavings,
          acc_selectedPortfolio,
          activeGlidePath,
          acc_fundSelected: { acc_fundName }
        }
      }
    }
  }) => ({
    age,
    selectedPlan,
    savings,
    income,
    shortfall,
    withdraw,
    dec_barchartData,
    rate,
    portfolio,
    excess,
    currentSavings,
    possibleAnnualSavings,
    acc_selectedPortfolio,
    dec_socialSecurity,
    dec_otherIncome,
    dec_investmentSource,
    activeGlidePath,
    fundName,
    acc_fundName
  }),
  null
)(BarChartHolder);



// WEBPACK FOOTER //
// ./src/components/pages/Retire/solution/barChartHolder.jsx